import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AlertTypes } from '@vendasta/galaxy/alert';
import { Observable } from 'rxjs';
import { A2PRegistrationService } from '../a2p-registration.service';
import { RegistrationStage } from '../a2p-registration.constants';

@Component({
  selector: 'sms-registration-alert',
  templateUrl: './sms-registration-alert.component.html',
  styleUrls: ['./sms-registration-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SmsRegistrationAlertComponent {
  @Input() alertType: AlertTypes = 'important';
  @Output() actionClick: EventEmitter<null> = new EventEmitter();
  @Output() closeClick: EventEmitter<null> = new EventEmitter();
  registrationStage$: Observable<RegistrationStage>;

  protected readonly RegistrationStage = RegistrationStage;

  constructor(private smsRegistrationService: A2PRegistrationService) {
    this.registrationStage$ = smsRegistrationService.registrationStage$;
  }

  actionClicked(): void {
    this.actionClick.emit();
  }

  closeClicked(): void {
    this.closeClick.emit();
  }
}
